import React from "react";
import { useState } from "react";
import Footer from "../components/layout/Footer";
import Navbar from "../components/layout/Navbar";
import {  residentialPlanPricing , businessPlanPricing } from "../mocks/pricingMocks";
import { Link } from "react-router-dom";

function Pricing() {
  // const [user, setUser] = useState(null);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="main-container">
      <Navbar />
      <div className="col-12 pricing-page">
        <div id="pricing">
          <div className="price-tag text-center col-lg-5 col-12 ml-auto mr-auto p-0">
            <h3>Tarification</h3>
            <p>
              Nous proposons différents forfaits ILLIMITÉS sans plafond de
              données, sans seuil d'utilisation et sans limite du nombre
              d'appareils pouvant être connectés.
              <br />
              Sélectionnez votre forfait préféré.
            </p>
          </div>
          <div className="col-md-4 m-auto">
            <ul className="nav nav-tabs">
              <li className="nav-item btn w-100">
                <a
                  className="nav-link active p-3"
                  data-toggle="tab"
                  href="#homePlan"
                  onClick={() => setIsOpen(false)}
                >
                  Plans de maison
                </a>
              </li>
              <li className="nav-item btn w-100">
                <a
                  className="nav-link p-3"
                  data-toggle="tab"
                  href="#"
                  onClick={() => setIsOpen(true)}
                >
                  Plans d'affaires
                </a>
              </li>
            </ul>
          </div>
          {isOpen === false ? (
             <PriceOptions pricing={residentialPlanPricing}/>
          ) : (
            <PriceOptions pricing={businessPlanPricing}/>
          )}
        </div>
      </div>
 
  
      <Footer />
    </div>
  );
}

export default Pricing;

//compressed in into a mockComponent
export const PriceOptions = ({pricing}) => (
  
  <div className="tab-content mt-5 mr-auto ml-auto col-md-8">
  <div className="tab-pane container active" id={pricing.name}>
    <div className="d-flex flex-wrap">
      {/* Added keys to childern node */}
      {pricing?.map((item, index) => {
        return (
          <div className={item.class} key={index}>
            {item.popular === true ? (
              <div className="most-picked p-3 mt-1">
                <h6>Les plus choisis</h6>
              </div>
            ) : null}

            <div className="price-border" key={index}>
              <div className="text-center add-bottom">
                <p className="mb-0">
                  FCFA
                  <span className="copy-font">
                    {item.price}/<small>{item.month}</small>
                  </span>
                </p>
                <h5>{item.plan}</h5>
              </div>
              <div className="p-3">
                <p>
                  <span className="mr-2">&#10003;</span>
                  plus FCFA <b>{item.setup}</b>
                  <br />
                  <span className="ml-4">
                    frais d'installation uniques
                  </span>
                </p>

                <p>
                  <span className="mr-2">&#10003;</span>
                  Internet illimité
                </p>
                {item.duration === true ? (
                  <p>
                    <span className="mr-2">&#10003;</span>
                    {item.time}
                  </p>
                ) : (
                  <p>
                    <span className="mr-2"> &#x02DF;</span>
                    <del>{item.time}</del>
                  </p>
                )}

                <p>
                  <span className="mr-2">&#10003;</span>
                  Assistance 24h/24 et 7j/7
                </p>
              </div>

              <div>
             
                <Link
                  className=""
                  id=""
                  to={`/sign-up`}
                  state={{
                    value: item.value,
                    plan : item.plan
                  }}
                >
                  <button
                    type="submit"
                    className="btn text-white signup-btn p-2 w-100"
                  >
                    S'inscrire
                  </button>
                </Link>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
</div>
)